import { render, staticRenderFns } from "./LogsTransactionList.vue?vue&type=template&id=771c5c0e&"
import script from "./LogsTransactionList.vue?vue&type=script&lang=js&"
export * from "./LogsTransactionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports